<template>
  <v-row>
    <input
      type="hidden"
      id="textToCopy"
      :value="textToCopy"
    />
    <v-col cols="6" v-for="(item, i) in listItems" :key="i">
      <v-list rounded shaped :elevation="1">
        <v-list-item-group>
          <v-list-item @click="copyToClipboard(item)">
            <v-list-item-icon>
              <v-icon :color="item.icon.color" v-text="item.icon"></v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-subtitle v-text="item.title">
              </v-list-item-subtitle>
              <v-list-item-title v-text="item.text">
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-col>
  </v-row>
</template>

<script>
  import moment from 'moment'
  
  export default {
    name: 'SessionInfoList',
    props: {
      session: Object
    },
    data () {
      return {
        textToCopy: ''
      }
    },
    methods: {
      setCopyText (text) {
        // setting this.textToCopy takes too long for the input to set its value
        // and so when the rest of copyToClipboard runs, it is not yet copying
        // the text. So instead, we have to wait 500ms for the input value to
        // be set, then we can continue to copy the text
        return new Promise((resolve) => {
          this.textToCopy = text
          setTimeout(() => {
            return resolve()
          }, 500)
        })
      },
      async copyToClipboard (item) {
        await this.setCopyText(item.text)
        let el = document.getElementById('textToCopy')
        el.setAttribute('type', 'text')
        el.select()
        try {
          let success = document.execCommand('copy')
          if (success) {
            this.$store.dispatch('setSnackbar', {
              snackbarColor: 'success',
              showSnackbar: true,
              snackbarY: 'top',
              snackbarX: 'right',
              snackbarText: `${item.title} copied to clipboard!`
            })
          }
        }
        catch (err) {
          this.$store.dispatch('setSnackbar', {
            snackbarColor: 'error',
            showSnackbar: true,
            snackbarY: 'top',
            snackbarX: 'right',
            snackbarText: `Unable to copy ${item.title} to clipboard!`
          })
        }
        el.setAttribute('type', 'hidden')
        window.getSelection().removeAllRanges()
      },
      formatDatetime (date) {
        const dt = moment(date)
        if (dt.hours() === 0 && dt.minutes() === 0) {
          return dt.format("dddd, MMMM Do, YYYY")
        } else {
          return dt.format("LLLL")
        }
      }
    },
    computed: {
      capacityListItem () {
        return {
          title: 'Capacity',
          text: this.session.fields['Attendee Count'] + ' / ' +
                (this.session.fields.Capacity || 'No Limit'),
          icon: 'mdi-ticket-confirmation-outline'
        }
      },
      locationListItem () {
        return {
          title: 'Location',
          text: this.session.fields.Location ? 
                this.session.fields.Location : 'TBD',
          icon: 'mdi-map-marker-outline'
        }
      },
      startListItem () {
        const item = { title: 'Start' }
        if (this.session.fields['Start']) {
          item.text = this.formatDatetime(this.session.fields['Start'])
          item.icon = 'mdi-calendar'
        } else {
          item.text = 'TBD'
          item.icon = 'mdi-calendar-remove-outline'
        }
        return item
      },
      endListItem () {
        const item = { title: 'End' }
        if (this.session.fields['End']) {
          item.text = this.formatDatetime(this.session.fields['End'])
          item.icon = 'mdi-calendar'
        } else {
          item.text = 'TBD'
          item.icon = 'mdi-calendar-remove-outline'
        }
        return item
      },
      hiddenListItem () {
        const item = { title: 'Hidden On Signup Page'}
        if (this.session.fields['Hide On Signup Page']) {
          item.text = 'true'
          item.icon = 'mdi-eye-off-outline'
        } else {
          item.text = 'false'
          item.icon = 'mdi-eye-outline'
        }
        return item
      },
      videoListItem () {
        const item = { title: 'Video Share Link' }
        if (this.session.fields['Video Share Link']) {
          item.text = this.session.fields['Video Share Link']
          item.icon = 'mdi-video-outline'
        } else {
          item.text = 'No video link'
          item.icon = 'mdi-video-off-outline'
        }
        return item
      },
      listItems () {
        return [
          this.capacityListItem,
          this.videoListItem,
          this.startListItem, 
          this.endListItem,
          this.locationListItem,
          this.hiddenListItem
        ]
      }
    }
  }
</script>
